<template>
  <div>
    <label class="item-name">{{initComponent.name}}</label>
    <div class="component-content">
      <el-input :readonly="true"></el-input>
    </div>
  </div>
</template>

<script>
import { componentMixin } from '../mixins'

export default {
  name: 'rc-uuid',
  props: ['initComponent'],
  mixins: [ componentMixin ],
  data () {
    return {
      component: this.initComponent
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/form/components/uuid/rc-uuid.vue